var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select ng-model=\"vm.data\" ng-required=\"vm.settings.required\" search-enabled=\"false\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ vm.display($select.selected) }} </ui-select-match> <ui-select-choices repeat=\"booleanRestrictions in vm.booleanRestrictions\"> <div>{{ vm.display(booleanRestrictions) }}</div> </ui-select-choices> </ui-select> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaBooleanRestrictionSelect.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaBooleanRestrictionSelect/lbaBooleanRestrictionSelect.html
// module id = 345
// module chunks = 0